var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5C4.16222 9.5 3.88852 9.2263 3.88852 8.88852V1.11148C3.88852 0.773698 4.16222 0.5 4.5 0.5C4.83778 0.5 5.11148 0.773698 5.11148 1.11148V8.88852C5.11148 9.2263 4.83778 9.5 4.5 9.5Z",
    fill: "#DBF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38852 5.61148H0.611479C0.273698 5.61148 0 5.33778 0 5C0 4.66222 0.273698 4.38852 0.611479 4.38852H8.38852C8.7263 4.38852 9 4.66222 9 5C9 5.33778 8.7263 5.61148 8.38852 5.61148Z",
    fill: "#DBF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.580667b7794faf42fa5f9fdd31889b7b.svg";
export { ForwardRef as ReactComponent };